import React, { useEffect } from "react";
import { useState } from "react";
import { QuestionsContext } from "./MyContexts";
import { useSheets } from "../hooks/useSheet";
import { getQuestion } from "../commands/api";
import { OptionHeader } from "../type";
import { getQuestionTitlesFromItemList, loadSheetValues } from "../commands/questions/excelInfo";

export default function QuestionsProvider(props: { children: React.ReactNode }) {
  const [isDeepThought, setIsDeepThought] = useState<boolean>(false);

  function toggleDeepThought() {
    console.log("toggleDeepThought", isDeepThought);
    setIsDeepThought((prev) => !prev);
  }

  const [questions, setQuestions] = useState<{ [key: string]: any }[]>([]);

  function updateQuestions(newQuestions: any[], dontAddHistory = false) {
    setQuestions(newQuestions);
    if (!dontAddHistory) {
      editHistory(newQuestions);
    }
  }

  function updateQuestionById(qId: string, newQuestion: any) {
    const newQuestions = questions.map((question) => {
      if (question.questionId === qId) {
        return { ...question, ...newQuestion };
      }
      return question;
    });
    updateQuestions(newQuestions);
  }

  function removeQuestion(index: number) {
    if (index !== undefined) {
      // インデックスで削除
      const newQuestions = [...questions];
      newQuestions.splice(index, 1);
      updateQuestions(newQuestions);
      return;
    }
    // if (!questionId) {
    //   const newQuestions = questions.filter((q) => q.questionId !== questionId);
    //   updateQuestions(newQuestions);

    //   return;
    // }
    return null;
  }

  const [history, setHistory] = useState<any[][]>([]);
  const [historyIndex, setHistoryIndex] = useState(0);

  function resetHistory(questions: any[]) {
    setHistory([questions]);
    setHistoryIndex(0);
  }

  // 編集関数：新しい配列で更新する
  const editHistory = (newQuestions?: any[]) => {
    let newItems = [...questions];

    if (newQuestions && newQuestions.length) {
      // 特定の質問を更新
      newItems = newQuestions;
    }

    // Redo用履歴を破棄して新しい履歴を追加
    const newHistory = history.slice(0, historyIndex + 1);
    newHistory.push(newItems);
    setHistory(newHistory);
    setHistoryIndex(newHistory.length - 1);
  };

  // Undo操作
  const undo = () => {
    setHistoryIndex((prevIndex) => {
      if (prevIndex > 0) {
        return prevIndex - 1;
      }
      return prevIndex;
    });
  };

  // Redo操作
  const redo = () => {
    setHistoryIndex((prevIndex) => {
      if (prevIndex < history.length - 1) {
        return prevIndex + 1;
      }
      return prevIndex;
    });
  };

  //  一つ前の時点との差分をkey単位で取得
  let changes = [];

  // present.map((question, index) => {
  //   const currentQuestion = questions[index];
  //   if (currentQuestion) {
  //     const changeKeys = Object.keys(question).filter(
  //       (key) => question[key] !== currentQuestion[key]
  //     );
  //     if (changeKeys.length > 0) {
  //       changes.push({
  //         questionId: question.questionId,
  //         keys: changeKeys,
  //       });
  //     }
  //   }
  // })

  // }, [historyIndex,present]);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [researchInfo, setResearchInfo] = useState({
    client: "",
    theme: "",
    backGround: "",
  });

  function updateResearchInfo(key: string, value: string) {
    setResearchInfo((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  const {
    sheets,
    loadSheetNames,
    selectedSheet,
    handleChangeSheet,
    itemSheets,
    selectedItemSheet,
    handleChangeItemSheet,
    editSheet,
    updateEditSheet,
    baseSheet,
    handleChangeBaseSheet,
    autoSetBaseSheet,
  } = useSheets();

  const {
    selectedQuestion,
    handleSelectedChange,
    moveToNextQuestion,
    moveToPrevQuestion,
    getNextQuestion,
    getPrevQuestion,
  } = useSelectedQuestion(questions);

  function addQuestion(insertIndex?: number) {
    insertIndex = insertIndex || questions.length;
    const newValue = [
      ...questions.slice(0, insertIndex),
      {
        questionId: `Q${questions.length + 1}`,
        questionTitle: "",
        questionText: "",
        questionType: "",
        options: [],
        loop: [],
        condition: "",
        optionHeaders: [],
        remarks: "",
        random: "",
        questionSupplementPrev: [],
        questionSupplement: [],
        forwardPageBreak: true,
      },
      ...questions.slice(insertIndex),
    ];

    // const newValue = [
    //   ...questions,
    //   {
    //     questionId: `Q${questions.length + 2}`,
    //     questionTitle: "",
    //     questionText: "",
    //     questionType: "",
    //     options: [],
    //     loop: [],
    //     condition: "",
    //     optionHeaders: [],
    //     remarks: "",
    //     random: "",
    //     questionSupplementPrev: [],
    //     questionSupplement: [],
    //     forwardPageBreak: true,
    //   },
    // ];

    updateQuestions(newValue);
  }

  function updateMatrixValue(id: string, value: string, key: string = "text") {
    const newValue = questions.map((question) => {
      if (question.questionId === selectedQuestion.questionId) {
        return {
          ...question,
          loop: question.loop.map((loop) => {
            if (loop.itemId === id) {
              return {
                ...loop,
                [key]: value,
              };
            } else {
              return loop;
            }
          }),
        };
      } else {
        return question;
      }
    });

    updateQuestions(newValue);
  }

  function updateOptionValue(id: string, value: string, key: string = "text") {
    const newValue = questions.map((question) => {
      if (question.questionId === selectedQuestion.questionId) {
        return {
          ...question,
          options: question.options.map((option) => {
            if (option.itemId === id) {
              return {
                ...option,
                [key]: value,
              };
            } else {
              return option;
            }
          }),
        };
      } else {
        return question;
      }
    });

    updateQuestions(newValue);
  }

  function updateQuestionValue(key: string, value: string | OptionHeader[]) {
    const newValue = questions.map((question) => {
      if (question.questionId === selectedQuestion.questionId) {
        return {
          ...question,
          [key]: value,
        };
      } else {
        return question;
      }
    });

    updateQuestions(newValue);
  }

  function addInitOption(questionType: string) {
    if (questionType.includes("マトリクス")) {
      const newValue = questions.map((question) => {
        if (question.questionId === selectedQuestion.questionId) {
          return {
            ...question,
            optionHeaders: [],
            loop: [
              {
                itemId: "1",
                text: "行1",
                condition: "",
                random: "",
                creative: "",
                answerType: questionType.includes("SA") ? "SA" : "MA",
                remarks: "",
              },
            ],
            options: [
              [
                {
                  itemId: "1",
                  text: "選択肢1",
                  condition: "",
                  exclusive: "",
                  random: "",
                  creative: "",
                  remarks: "",
                },
              ],
            ],
          };
        }
        return question;
      });
      updateQuestions(newValue, true);
    } else {
      const newValue = questions.map((question) => {
        if (question.questionId === selectedQuestion.questionId) {
          return {
            ...question,
            optionHeaders: [],
            options: [
              [
                {
                  itemId: "1",
                  text: "選択肢1",
                  condition: "",
                  exclusive: "",
                  random: "",
                  creative: "",
                  remarks: "",
                },
              ],
            ],
          };
        }
        return question;
      });
      updateQuestions(newValue, true);
    }
  }

  async function generateQuestion(target = "ALL") {
    setIsLoading(true);

    const requestObj = {
      ...researchInfo,
      selectedQuestion,
      questions,
      target,
      reasoning: isDeepThought,
    };
    let newValue = selectedQuestion;
    newValue = await getQuestion(requestObj);

    const newQuestions = questions.map((question) => {
      if (question.questionId === selectedQuestion.questionId) {
        return newValue || selectedQuestion;
      }
      return question;
    });

    updateQuestions(newQuestions);
    setIsLoading(false);
  }

  function handleChangeQuestionType(newValue: string) {
    const newValues = questions.map((question) => {
      if (question.questionId === selectedQuestion.questionId) {
        return {
          ...question,
          questionType: newValue,
        };
      } else {
        return question;
      }
    });
    updateQuestions(newValues);
  }

  const [loadig, setLoading] = useState<boolean>(false);

  async function loadSheetData(sheetType: string) {
    setLoading(true);
    if (sheetType == "form") {
      const { questions, checkResultsExcel } = await loadSheetValues(selectedSheet);
      setQuestions(questions);
      resetHistory(questions);
    } else if (sheetType == "item") {
      const questionTitles = await getQuestionTitlesFromItemList(selectedItemSheet);
      const questions = questionTitles.map((question, i) => {
        return {
          ...question,
          questionId: question.questionId || `Q${i + 1}`,
          loop: [],
          options: [],
          optionHeaders: [],
          remarks: "",
          random: "",
          questionSupplementPrev: [],
          questionSupplement: [],
          forwardPageBreak: true,
        };
      });
      setQuestions(questions);
      resetHistory(questions);
    } else {
      setQuestions([]);
      resetHistory([]);
    }
    setLoading(false);
  }

  useEffect(() => {
    // 履歴とQuestionの同期
    updateQuestions(history[historyIndex] || [], true);
  }, [historyIndex]);

  return (
    <QuestionsContext.Provider
      value={{
        questions,
        setQuestions,
        updateQuestions,
        removeQuestion,
        updateQuestionById,

        loadSheetData,
        loadig,

        addQuestion,
        addInitOption,
        selectedQuestion,
        handleSelectedChange,

        sheets,
        loadSheetNames,
        selectedSheet,
        handleChangeSheet,
        editSheet,
        updateEditSheet,
        autoSetBaseSheet,

        generateQuestion,

        handleChangeQuestionType,
        isLoading,
        moveToNextQuestion,
        moveToPrevQuestion,
        getNextQuestion,
        getPrevQuestion,
        updateQuestionValue,
        itemSheets,
        selectedItemSheet,
        handleChangeItemSheet,

        baseSheet,
        handleChangeBaseSheet,

        updateMatrixValue,
        updateOptionValue,

        researchInfo,
        updateResearchInfo,

        historyIndex,
        undo,
        redo,

        isDeepThought,
        toggleDeepThought,
      }}
    >
      {props.children}
    </QuestionsContext.Provider>
  );
}

function useSelectedQuestion(questions: any[]) {
  const [selected, setSelected] = useState<number>(0);

  function moveToNextQuestion() {
    setSelected(getNextQuestion());
  }

  function moveToPrevQuestion() {
    setSelected(getPrevQuestion());
  }

  function getNextQuestion() {
    if (selected + 1 < questions.length) {
      return selected + 1;
    } else if (selected + 1 === questions.length) {
      return 0;
    } else {
      return selected;
    }
  }

  function getPrevQuestion() {
    if (selected - 1 >= 0) {
      return selected - 1;
    } else if (selected - 1 < 0) {
      return questions.length - 1;
    } else {
      return selected;
    }
  }

  function handleSelectedChange(newSelected: number) {
    setSelected(newSelected);
  }

  const selectedQuestion = selected < questions.length ? questions[selected] : undefined;

  return {
    selectedQuestion,
    handleSelectedChange,
    moveToNextQuestion,
    moveToPrevQuestion,
    getNextQuestion,
    getPrevQuestion,
  };
}
